import { render } from "./adminDetail.vue?vue&type=template&id=47facf0f&scoped=true&ts=true"
import script from "./adminDetail.vue?vue&type=script&lang=ts&config=true"
export * from "./adminDetail.vue?vue&type=script&lang=ts&config=true"

import "./adminDetail.vue?vue&type=style&index=0&id=47facf0f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47facf0f"]])

export default __exports__